import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-423d6e15")

_pushScopeId("data-v-423d6e15")
const _hoisted_1 = { class: "c-footer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, "Uhshin Admin", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _createTextVNode(" © " + _toDisplayString(_ctx.currentYear), 1)
    ])
  ]))
})